// extracted by mini-css-extract-plugin
export var fontsLoading = "videoEmbed-module--fonts-loading--MpwqV";
export var fullWidth = "videoEmbed-module--fullWidth--dWGvj";
export var largeWidth = "videoEmbed-module--largeWidth--svnvw";
export var middleWidth = "videoEmbed-module--middleWidth--7h4EA";
export var videoEmbedWrap = "videoEmbed-module--videoEmbedWrap--RwsT+";